<template>
  <a-layout-header class="pr-layout-header">
    <div class="header-logo">
      <img src="@/assets/logo-project2.png" />
    </div>

    <pr-menu v-if="hasMenus" />
    <div v-else></div>
    <div class="header-message" v-if="role.indexOf('d') === -1">
      <a-dropdown
        :trigger="['click']"
        v-model:visible="letterBoxVisible"
        class="header-message-content"
        @visibleChange="messageVisibleChange"
      >
        <a class="ant-dropdown-link" @click.prevent>
          <a-badge :count="unReadMessageCount">
            <svg-icon icon-class="message" class="hm-msg-icon" />
          </a-badge>
          <svg-icon icon-class="caret-down" class="hm-arrow-icon" />
        </a>
        <template #overlay>
          <div class="message-wrap">
            <div class="message-title">
              {{ $t('user.Message') }} ({{ unReadMessageCount }})
            </div>
            <a-menu class="message-list">
              <a-menu-item
                v-for="(msg, msgIndex) in messages
                  .slice(0, unReadMessageCount)
                  .slice(0, 5)"
                :key="msg.id"
                class="message-item"
              >
                <!-- <a href="javascript:;">1st menu item</a> -->
                <div class="msg-wrap" @click="handleClick(msg)">
                  <div class="msg-status">
                    <div
                      :class="`status-icon ${msg.is_read ? 'gray' : 'red'}`"
                    />
                  </div>
                  <div class="msg-content">
                    <div class="msg-text">{{ msg.message }}</div>
                    <div class="msg-date">{{ msg.time }}</div>
                  </div>
                  <div class="msg-icon" @click="removeMessage(msgIndex)">
                    <svg-icon icon-class="message-delete"></svg-icon>
                  </div>
                </div>
              </a-menu-item>
            </a-menu>
            <a-menu
              class="message-list"
              v-if="unReadMessageCount === 0 || unReadMessageCount > 5"
            >
              <div class="message-item">
                <div class="msg-wrap-div" @click="handleClick">
                  <div class="msg-content">
                    <div class="msg-text-all">
                      {{ $t('user.View all message') }}
                    </div>
                  </div>
                </div>
              </div>
            </a-menu>
          </div>
        </template>
      </a-dropdown>
    </div>
    <pr-lang />
  </a-layout-header>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PrMenu from '../pr-menu'
  import PrLang from '../pr-lang'
  import {
    getMessageList,
    delMessage,
    readMessage,
    readAllMessage,
  } from '@/api/message'
  import { message } from 'ant-design-vue'
  import bus from '@/lib/bus'

  export default {
    name: 'PrHeader',
    components: { PrMenu, PrLang },
    props: {
      hasMenus: {
        default: true,
        type: Boolean,
      },
    },

    data() {
      return {
        letterBoxVisible: false,
        messages: [],
      }
    },
    computed: {
      unReadMessageCount() {
        return this.messages.filter((item) => !item.is_read).length
      },
      ...mapGetters({
        role: 'acl/role',
      }),
    },
    mounted() {
      this.fetchMsg()
      bus.on('fetchMsg', this.fetchMsg)
    },
    methods: {
      fetchMsg() {
        getMessageList().then((res) => {
          if (res.code == 200) {
            this.messages = res.data
          }
        })
      },
      handleClick() {
        if (window.location != '#/notification') {
          this.letterBoxVisible = false
          this.messageVisibleChange(false)
          this.$router.push('/notification')
        }
      },
      handleMessageClick(msg) {
        const msgID = msg.id
        readMessage(msgID).then((res) => {
          if (res.code == 200) {
            const msg = this.messages.find((item) => item.id === msgID)
            msg.is_read = true
          }
        })
      },
      removeMessage(msgIndex) {
        const msgID = this.messages[msgIndex].id
        delMessage(msgID).then((res) => {
          if (res.code == 200) {
            this.messages.splice(msgIndex, 1)
            message.success(this.$t('user.Message deleted'))
          }
        })
      },
      messageVisibleChange(visible) {
        if (!visible) {
          // 关闭后所有消息已读
          readAllMessage().then(() => {
            this.messages = this.messages.map((item) => {
              item.is_read = true
              return item
            })
          })
        }
      },
    },
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');
  .pr-layout-header {
    background-color: black;
    height: @app-header-height;
    padding: 17px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-logo {
      width: 167px;
      height: 26px;
      display: flex;
      margin-right: 36px;
      img {
        object-fit: contain;
        height: 100%;
      }
    }
    .header-message {
      color: white;
      &-content {
        display: flex;
        align-items: center;
      }
      .svg-icon {
        color: white;
        // margin: 0 8px;
      }
      .hm-msg-icon {
        font-size: 24px;
      }
      .hm-arrow-icon {
        margin-left: 15px;
        font-size: 10px;
      }
    }
  }
  .message-wrap {
    background: rgb(255, 255, 255);
    width: 336px;
    box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
      0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    .ant-menu-item {
      height: auto !important;
      margin: 0;
      padding: 10px 6px !important;

      line-height: initial !important;
    }
  }
  .message-title {
    font-size: 16px;
    // font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #000000;
    line-height: 24px;
    padding: 10px 16px;
  }
  .message-list {
    max-height: 500px;
    overflow: auto;
    .message-item {
      border-top: 1px solid #00000014;
    }
    .msg-wrap {
      display: flex;
      align-items: center;
      font-size: 14px;

      &-div {
        width: 100%;
        padding: 10px 16px;
        cursor: pointer;
      }
    }
    .msg-content {
      line-height: 22px;
      font-size: 14px;
      .msg-text {
        width: 234px;
        color: #333333;
        margin-bottom: 6px;
        word-break: break-word;
        white-space: normal;

        &-all {
          vertical-align: middle;
        }
      }
      .msg-date {
        color: #666666;
      }
    }
    .msg-icon {
      padding: 10px 18px;
    }
    .msg-status {
      padding: 15px;
      .status-icon {
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background-color: #999;
        &.red {
          background-color: #f44336;
        }
      }
    }
  }
</style>
